import AbstractEventModel  from './AbstractEventModel';
import doc                 from '@widesk-core/decorators/doc';
import { Translatable }    from '@widesk-core/decorators/translatable';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import { computed }        from 'mobx';
import appStore            from '@/stores/appStore';
import { Dayjs }           from 'dayjs';
import dayjs               from 'dayjs';

@doc.urnResource('event')
@doc.translatable({ title: true, shortTitle: true, content: true, lead: true })
class EventModel extends AbstractEventModel {
	public get pagePathPrefix() {
		return `/website_entertainments/${this.get('websiteEntertainment.id')}`;
	}

	public renderName(props?: RenderNameProps<this> & EventNameProps) {
		return super.renderName(props);
	}

	static get prefix() {
		return '/evenements/';
	}

	static get urlPrefix() {
		return `${appStore.websiteEntertainment?.url}${this.prefix}`;
	}

	getUrl(complete = false) {
		const path = EventModel.urlPrefix + this.slug;
		if (complete) {
			return appStore.websiteEntertainment?.website.url + path;
		}

		return path;
	}

	get status() {
		return this.eventStatus;
	}

	@computed get contentToPublish() {
		return appStore.collContentToPublish
			.find(m => m.objectUrn === this.urn) || undefined;
	}

	get isPublishScheduled() {
		return this.contentToPublish?.contentToPublishStatus.reference === 'ENABLED';
	}

	@computed get startDate(): Dayjs | undefined {
		const time = this.start;
		if (!time) return this.date?.clone();

		const date = this.date?.clone() || dayjs();
		const [hours, minutes, seconds] = time.format('HH:mm:ss')
			.split(':')
			.map(Number);

		return date.clone()
			.hour(hours as number).minute(minutes as number).second(seconds as number);
	}

	@computed get endDate(): Dayjs | undefined {
		const time = this.end;
		if (!time) return this.date?.clone();

		const date = this.date?.clone() || dayjs();
		const [hours, minutes, seconds] = time.format('HH:mm:ss')
			.split(':')
			.map(Number);

		return date.clone()
			.hour(hours as number).minute(minutes as number).second(seconds as number);
	}

	get startDateValue() {
		return this.startDate?.valueOf() || 0;
	}
}

interface EventModel
	extends Translatable<{ title: true, shortTitle: true, content: true, lead: true }> {
}

export default EventModel;
